// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1rw4u","label":"Radio_label__24l9e","checkMark":"Radio_checkMark__3V9mR","disabled":"Radio_disabled__2p1-g"};